import React, { useEffect, useState } from "react";
import { useTabContext } from "../context/context";
import { usePermissions } from "../data/Permissions";
import { useFormContext } from "react-hook-form";
import ProviderLinks from "../components/ProviderLinks";
import Amenities from "../components/Amenities";
import MediaUploads from "../components/MediaUploads";
import Description from "../components/Description";
import { htmlToText } from "html-to-text";

const Premium = () => {
  const { permissions } = usePermissions();

  const { provID, isPremium, providerInfo, setPremiumChangesMade } = useTabContext();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="provider-section md:col-span-3">
        <h3>Premium Features</h3>
        {!isPremium ? (
          <React.Fragment>
            <div className="text-xl text-primaryBlue font-semibold my-2 w-[90%] p-2 border rounded-md border-primaryBlue mx-auto bg-primaryBlue-20">The additional marketing options on this page are only visible to the public by upgrading to a Premium profile.</div>
            <div>You can add your logo, photos, video, social media links, brochures, company description, and amenities now- but they will not be visible to the public until you upgrade to Premium. Adding these additional marketing options start at just $250, learn more about upgrading your listing to Premium and enjoy all the perks!</div>
            <div className="text-center font-semibold mx-auto rounded-lg border w-40 border-teal-900 bg-primaryBlue px-2 py-1  text-white">
              <a href={`/stripe/?ID=${provID}`} target="_blank" className="text-white hover:text-secondaryColor">
                Learn More!
              </a>
            </div>
          </React.Fragment>
        ) : (
          <div className="text-sm pt-2">
            Thank you for your continued support! However, we understand things change and if you would like to cancel your premium membership for {providerInfo.name}, please email us at <a href={`mailto:amy@careavailability.com?subject=I%20would%20like%20to%20cancel%20my%20premium%20membership%20to%20${providerInfo.name} | Provider ID ${providerInfo.ID}`}>amy@careavailability.com</a>. <br />
            Please include the name of your company, and this ID: <b>{providerInfo.ID}</b>
          </div>
        )}
      </div>
      <div className="md:col-span-3">
        <Description isPremium={isPremium} setPremiumChangesMade={setPremiumChangesMade} />
      </div>

      <ProviderLinks isPremium={isPremium} setPremiumChangesMade={setPremiumChangesMade} />

      <MediaUploads isPremium={isPremium} setPremiumChangesMade={setPremiumChangesMade} />

      <Amenities isPremium={isPremium} setPremiumChangesMade={setPremiumChangesMade} />
    </div>
  );
};

export default Premium;
